import { RequestMultiValuedList } from '../RequestMultiValuedList'
import { RequestTag } from '../RequestTag'

import {
  filterByTitleAndNumber,
  sortServiceRequestsMoreItems,
} from './RequestTagMultiValuedList.utils'

import * as styles from './RequestTagMultiValuedList.module.css'

function RequestTagMultiValuedList({
  filter = filterByTitleAndNumber,
  items,
  moreProps,
  sortMoreItems = sortServiceRequestsMoreItems,
  ...restProps
}) {
  return (
    <RequestMultiValuedList
      {...restProps}
      Item={RequestTag}
      filter={filter}
      items={items}
      moreProps={{
        ...moreProps,
        className: moreProps?.className || styles.moreBtn,
      }}
      sortMoreItems={sortMoreItems}
    />
  )
}

export default RequestTagMultiValuedList
